import { withTranslation } from 'react-i18next';

import ConfirmModal from '@components/ConfirmModal';

import { IConfirmLogoutModalView } from './interfaces';
import { env } from 'env';
import { useMytaverse } from '@providers/MytaverseProvider';

const { REACT_APP_PAGE_TITLE = 'Metaplexus Hub' } = env;

const ConfirmLogoutModalView = ({
  open,
  onClose,
  onExitButtonClick,
  altStyling = false,
  onCancelAltAction,
  showFeedback,
  t: translate,
}: IConfirmLogoutModalView) => {
  const { appTheme } = useMytaverse();

  if (altStyling) {
    return (
      <ConfirmModal
        open={open}
        title={
          showFeedback
            ? translate('logoutConfirm.feedback')
            : translate('logoutConfirm.titleHub')
        }
        message={
          showFeedback
            ? ''
            : translate('logoutConfirm.descriptionHub', {
                platform:
                  appTheme.loginPage.typography.title || REACT_APP_PAGE_TITLE,
              })
        }
        onConfirm={onExitButtonClick}
        onCancel={onClose}
        cancelButtonName={
          showFeedback
            ? translate('logoutConfirm.takeSurvey')
            : translate('logoutConfirm.stayHub')
        }
        onCancelAltAction={showFeedback ? onCancelAltAction : null}
        confirmButtonName={translate('logoutConfirm.exitHub')}
        altStyling
      />
    );
  }

  return (
    <ConfirmModal
      open={open}
      title={translate('logoutConfirm.title')}
      message={translate('logoutConfirm.description')}
      onConfirm={onExitButtonClick}
      onCancel={onClose}
    />
  );
};

export default withTranslation()(ConfirmLogoutModalView);
